<template>
  <v-row class="ma-0 pa-0">
    <v-col
      align="center"
      cols="8"
      offset="2"
      class="pa-0 pt-3"
    >
      <h2 class="titleThanks">
        {{ $translate('USER_PROGRESS_UNSUBSCRIBED') }}
      </h2>
    </v-col>
    <v-col
      v-if="userUnsubscribed || success === 'failed'"
      align="center"
      justify="center"
      class="py-5"
    >
      <v-icon
        size="20"
        @click="$emit('triggerPopup', {toggle: false, component:'Login'})"
      >
        ti-close
      </v-icon>
    </v-col>
  <v-col
    align="center"
    v-if="!userUnsubscribed && success === 'loading'"
    justify="center"
    class="py-16"
  >
    <v-progress-circular
      :size="70"
      :width="6"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </v-col>
    <v-col
      align="center"
      v-else-if="!userUnsubscribed && success === 'failed'"
      justify="center"
      class="py-5"
    >
      <v-icon
        size="140"
        color="#e83535"
      >
        clear
      </v-icon>
    </v-col>
  <v-col
    v-else-if="userUnsubscribed && success === 'success'"
    align="center"
    justify="center"
    class="py-5"
  >
    <v-icon
      size="140"
      color="#a7dc86"
    >
      done_outline
    </v-icon>
  </v-col>
    <v-row justify="center" class="pa-4 my-0">
      <h4
        v-if="userUnsubscribed && success === 'success'"
      >
        {{ $translate('USER_SUCCESS_UNSUBSCRIBED') }}
      </h4>
      <h4
        v-else-if="!userUnsubscribed && success === 'failed'"
      >
        {{ $translate('USER_FAILED_UNSUBSCRIBED') }}
      </h4>
    </v-row>
  </v-row>
</template>

<script>
import uiHelpers from '@/shared/ui_helpers';
import doRequest from '@/api/dssRequest';

export default {
  name: 'AccountUnsubscribe',
  mixins: [uiHelpers],
  created() {
  },
  mounted() {
    this.unsubscribeUser();
  },
  data() {
    return {
      userUnsubscribed: false,
      success: 'loading',
    };
  },
  methods: {
    closeDialog() {
      this.$emit('triggerPopup', { toggle: false, component: 'Unsubscribe' });
      this.goToPage('Homepage');
    },
    getSourceKeyFromURL() {
      // get the url
      const url_string = window.location.href;
      const url = new URL(url_string);
      // find the SourceKey paramater and read the value
      const sourceKey = url.searchParams.get('SourceKey');
      // if sourceKey is not available set an empty string
      return sourceKey || '';
    },
    unsubscribeUser() {
      // get the source key from the url
      const sourceKey = this.getSourceKeyFromURL();
      const payload = {
        Email: this.$store.getters.getUserToUnsubscribe.User,
        SourceKey: sourceKey,
      };
      doRequest(
        () => {
          this.userUnsubscribed = true;
          this.success = 'success';
          this.$store.commit('setUserToUnsubscribe', {});
        },
        () => {
          this.success = 'failed';
        },
        'unsubscribeUser',
        `${this.$store.getters.getUserToUnsubscribe.Account}_UG_${this.$store.getters.getUserToUnsubscribe.Partner}`,
        payload,
      );
    },
  },
};
</script>

<style scoped>
</style>
